// A permission policy as agent.yaml writes it: CMA's three words. Its own module, with no
// `yaml` behind it, so the block schemas (schema.ts) and through them the wire
// (`contracts/src/api/projects.ts`) read it without loading the codec; `tool-states.ts`
// re-exports it for the codec's readers.
export const TOOL_POLICIES = ["always_allow", "always_ask", "auto"];
//# sourceMappingURL=policies.js.map